import { memo } from 'react'
import PropTypes from 'prop-types'

import { ConfirmationDialog } from '@collaborate-health/uikit'

const DeleteReportUserConfirmationDialog = ({ open, onClose, onSubmit }) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      title='Are you sure you want to delete this report user?'
      submitButtonText='Yes'
      cancelButtonText='No'
    />
  )
}

DeleteReportUserConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default memo(DeleteReportUserConfirmationDialog)
